import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./EventList.css";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  addDoc,
} from "firebase/firestore";

const minTshAmount = 10000;
const minUsdtAmount = 5;

export default function Betting() {
  const [activeTab, setActiveTab] = useState("ALL");
  const [searchTerm, setSearchTerm] = useState("");
  const [username, setUsername] = useState("");
  const [topMessage, setTopMessage] = useState("");
  const [tshBalance, setTshBalance] = useState(0);
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [matches, setMatches] = useState([]);
  const [goMatches, setGoMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [selectedScore, setSelectedScore] = useState(null);
  const [betAmount, setBetAmount] = useState("");
  const [betCurrency, setBetCurrency] = useState("TSH");
  const [message, setMessage] = useState("");
  const [isPlacing, setIsPlacing] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const uname = localStorage.getItem("username");
    if (uname) {
      setUsername(uname);
      fetchUserBalance(uname);
    }
    fetchMatches();
  }, []);

  useEffect(() => {
    filterGoMatches(matches);
  }, [matches]);

  async function fetchUserBalance(uname) {
    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("username", "==", uname));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const userDoc = snapshot.docs[0];
        const data = userDoc.data();
        setTshBalance(Number(data.tshBalance) || 0);
        setUsdtBalance(Number(data.usdtBalance) || 0);
      }
    } catch (error) {
      console.error("Error fetching user balance:", error);
    }
  }

  async function fetchMatches() {
    try {
      const matchesRef = collection(db, "matches");
      const snapshot = await getDocs(matchesRef);
      const matchList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMatches(matchList);
      filterGoMatches(matchList);
    } catch (error) {
      console.error("Error fetching matches:", error);
    }
  }

  // ========== FIXED: GO disappear + OK PRIORITY ==========
  function filterGoMatches(matchList = []) {
    const now = new Date();

    const goList = matchList.filter((m) => {
      if (!m.matchDate || !m.matchTime) return false;

      // time logic: disappear 10 min before
      const [hh, mm] = m.matchTime.split(":");
      const matchDateTime = new Date(m.matchDate);
      matchDateTime.setHours(parseInt(hh));
      matchDateTime.setMinutes(parseInt(mm));
      matchDateTime.setSeconds(0);

      const tenMinBefore = new Date(matchDateTime.getTime() - 10 * 60 * 1000);
      if (now >= tenMinBefore) return false;

      // must be GO match or OK match
      const textCheck = (o) => {
        const s = String(o.score || "").toLowerCase();
        return (
          s.includes("go") ||
          s.includes("goal") ||
          s.includes("bao")
        );
      };

      // OK priority
      if (m.ok && m.ok.score && m.ok.odds) return true;

      // GO next
      if (m.go && m.go.score && m.go.odds) return true;

      // scoreOdds last
      if (Array.isArray(m.scoreOdds)) {
        return m.scoreOdds.some(textCheck);
      }

      return false;
    });

    setGoMatches(goList);
  }

  function getDateString(offsetDays = 0) {
    const date = new Date();
    date.setTime(date.getTime() + 3 * 60 * 60 * 1000);
    date.setDate(date.getDate() + offsetDays);
    return date.toISOString().split("T")[0];
  }

  function getDayName(dateString) {
    const days = [
      t("Sunday"),
      t("Monday"),
      t("Tuesday"),
      t("Wednesday"),
      t("Thursday"),
      t("Friday"),
      t("Saturday"),
    ];
    const date = new Date(dateString);
    return days[date.getDay()];
  }


  function formatTime(time24h) {
    if (!time24h) return "";
    const [h, m] = time24h.split(":");
    let hour = parseInt(h, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${time24h} (${hour12}:${m} ${ampm})`;
  }

  function filteredMatches() {
    const today = getDateString(0);
    const tomorrow = getDateString(1);
    const now = new Date();

    return matches.filter((m) => {
      if (!m.matchDate || !m.matchTime) return false;

      const [hours, minutes] = m.matchTime.split(":");
      const matchDateTime = new Date(m.matchDate);
      matchDateTime.setHours(parseInt(hours));
      matchDateTime.setMinutes(parseInt(minutes));

      const tenMinBefore = new Date(
        matchDateTime.getTime() - 10 * 60 * 1000
      );
      if (now >= tenMinBefore) return false;

      if (activeTab === "TODAY" && m.matchDate !== today) return false;
      if (activeTab === "TOMORROW" && m.matchDate !== tomorrow) return false;

      if (searchTerm.trim()) {
        const term = searchTerm.toLowerCase();
        return (
          m.teamA.toLowerCase().includes(term) ||
          m.teamB.toLowerCase().includes(term)
        );
      }

      return true;
    });
  }

  async function updateUserBalance(uname, newBalances) {
    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("username", "==", uname));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const userDoc = snapshot.docs[0];
        await updateDoc(userDoc.ref, newBalances);
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  }

  async function generateUniqueTicket() {
    const userBetsRef = collection(db, "userBets");
    let ticket = "";
    let exists = true;

    while (exists) {
      ticket = "";
      for (let i = 0; i < 20; i++) {
        ticket += Math.floor(Math.random() * 10);
      }

      const q = query(userBetsRef, where("ticketNumber", "==", ticket));
      const snapshot = await getDocs(q);
      exists = !snapshot.empty;
    }

    return ticket;
  }

  async function handleBuy() {
    if (isPlacing) return;
    setIsPlacing(true);
    setMessage("");
    const amountNum = Number(betAmount);

    if (!amountNum || amountNum <= 0) {
      setMessage("⚠️ Please enter a valid bet amount");
      setIsPlacing(false);
      return;
    }
    if (!selectedMatch || !selectedScore) {
      setMessage("⚠️ Please select a match and score first");
      setIsPlacing(false);
      return;
    }

    const oddsObj = selectedMatch.scoreOdds.find(
      (o) => o.score === selectedScore
    );
    const oddsValue = oddsObj ? parseFloat(oddsObj.odds) : 0;

   

    if (!["TSH", "USDT"].includes(betCurrency)) {
      setMessage("⚠️ Please select TSH or USDT");
      setIsPlacing(false);
      return;
    }

    if (betCurrency === "TSH") {
      if (amountNum < minTshAmount) {
        setMessage(`⚠️ Minimum TSH bet is ${minTshAmount}`);
        setIsPlacing(false);
        return;
      }
      if (amountNum > tshBalance) {
        setMessage("⚠️ Not enough TSH");
        setIsPlacing(false);
        return;
      }
    }

    if (betCurrency === "USDT") {
      if (amountNum < minUsdtAmount) {
        setMessage(`⚠️ Minimum USDT bet is ${minUsdtAmount}`);
        setIsPlacing(false);
        return;
      }
      if (amountNum > usdtBalance) {
        setMessage("⚠️ Not enough USDT");
        setIsPlacing(false);
        return;
      }
    }

    try {
      const userBetsRef = collection(db, "userBets");
      const today = getDateString(0);

      const q = query(
        userBetsRef,
        where("username", "==", username),
        where("matchDate", "==", today)
      );
      const snapshot = await getDocs(q);

      const maxBetsPerDay = 2;

      if (snapshot.size >= maxBetsPerDay) {
        setMessage("⚠️ Umeruhusiwa kucheza michezo miwili tu kwa siku");
        setIsPlacing(false);
        return;
      }

      const profit = (amountNum * oddsValue) / 100;
      const payout = amountNum + profit;
      const ticket = await generateUniqueTicket();

      const updateField =
  betCurrency === "TSH"
    ? { tshBalance: Number(tshBalance) - Number(amountNum) }
    : { usdtBalance: Number(usdtBalance) - Number(amountNum) };

    await addDoc(userBetsRef, {
      username,
      ticketNumber: ticket,
      teamA: selectedMatch.teamA,
      teamB: selectedMatch.teamB,
      selectedScore,
      odds: oddsValue,
      betAmount: amountNum,
      profit,
      payout,
      currency: betCurrency,
      betTime: new Date().toISOString(),
      matchTime: selectedMatch.matchTime,
      matchDate: selectedMatch.matchDate,
    });
    
    // update balance kwenye Firestore
    await updateUserBalance(username, updateField);
    
    // ================= UPDATE UI STATE =================
    
    // update balance ya UI (TZS / USDT)
    if (betCurrency === "TSH") {
      setTshBalance(prev => prev - amountNum);
    } else {
      setUsdtBalance(prev => prev - amountNum);
    }
    
    // ondoa mchezo uliobeti ili usirudiwe
    setMatches(prev =>
      prev.filter(m => m.id !== selectedMatch.id)
    );
    
    setGoMatches(prev =>
      prev.filter(m => m.id !== selectedMatch.id)
    );
    
    // message ya mafanikio
    setTopMessage("✅ Bet successful");

// ifute baada ya sekunde 3
setTimeout(() => {
  setTopMessage("");
}, 3000);
    
    // reset selections
    setSelectedMatch(null);
    setSelectedScore(null);
    setBetAmount("");
    } catch (error) {
      console.error("Bet error:", error);
      setMessage("❌ Error saving bet");
    } finally {
      setIsPlacing(false);
    }
  }

  function categorizeScoreOdds(scoreOdds = []) {
    const home = [];
    const draw = [];
    const away = [];

    scoreOdds.forEach((odd) => {
      const s = odd.score || "";
      if (s.toLowerCase().includes("other")) {
        draw.push(odd);
        return;
      }

      const parts = s.split("-");
      if (parts.length !== 2) {
        draw.push(odd);
        return;
      }

      const homeGoals = parseInt(parts[0].trim(), 10);
      const awayGoals = parseInt(parts[1].trim(), 10);

      if (isNaN(homeGoals) || isNaN(awayGoals)) {
        draw.push(odd);
        return;
      }

      if (homeGoals > awayGoals) home.push(odd);
      else if (homeGoals === awayGoals) draw.push(odd);
      else away.push(odd);
    });

    return { home, draw, away };
  }

  // ================== UI ==================
  if (!selectedMatch) {
    return (
      <div className="betting-container">
  
        {topMessage && (
          <div className="top-success-message">
            {topMessage}
          </div>
        )}
        
        {/* ANTBET BOX */}
        {goMatches.length > 0 && (
          <div className="antbet-box">
            <h3 className="antbet-title">⚽ AntBet — Ant Score  No Risk  </h3>

            {goMatches.map((m, idx) => {
              // OK PRIORITY → GO → scoreOdds
              let goSource = null;

              if (m.ok && m.ok.score && m.ok.odds) {
                goSource = m.ok;
              } else if (m.go && m.go.score && m.go.odds) {
                goSource = m.go;
              } else if (Array.isArray(m.scoreOdds)) {
                goSource = m.scoreOdds.find((o) => {
                  const s = String(o.score || "").toLowerCase();
                  return (
                    s.includes("go") ||
                    s.includes("goal") ||
                    s.includes("bao")
                  );
                });
              }

              const goScore = goSource?.score || "GO";
              const goOdds = goSource?.odds
                ? Number(goSource.odds).toFixed(2)
                : "?";

              return (
                <div
                  key={idx}
                  className="antbet-card"
                  onClick={() => setSelectedMatch(m)}
                >
                  <div className="antbet-row">
                    <span className="ant-team">{m.teamA}</span>
                    <span className="ant-vs">VS</span>
                    <span className="ant-team">{m.teamB}</span>
                  </div>

                  <div className="ant-date">
                    {m.matchDate} Time {formatTime(m.matchTime)}                  </div>

                  <div className="ant-go-score"> {goScore}</div>
                  Score:<strong>{goScore}</strong>

                  <div className="ant-go-odds">
                    Odds: <strong>{goOdds}%</strong>
                  </div>
                </div>
              );
            })}
         Click here and select these score </div>
        )}

        {/* TABS */}
        <div className="tabs">
          <button
            className={activeTab === "ALL" ? "active" : ""}
            onClick={() => setActiveTab("ALL")}
          >
            {t("Matches")}
          </button>
          <button
            className={activeTab === "TODAY" ? "active" : ""}
            onClick={() => setActiveTab("TODAY")}
          >
            {t("Today")}
          </button>
          <button
            className={activeTab === "TOMORROW" ? "active" : ""}
            onClick={() => setActiveTab("TOMORROW")}
          >
            {t("Tomorrow")}
          </button>
        </div>

        {/* SEARCH */}
        <input
          type="text"
          placeholder={t("Search")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        {/* MATCH LIST */}
        <div className="matches-list">
          {filteredMatches().map((match, idx) => (
            <div
              key={idx}
              className="match-item"
              onClick={() => setSelectedMatch(match)}
            >
              <div>
                {match.teamA} vs {match.teamB}
              </div>
              <div>
                {match.matchDate} {formatTime(match.matchTime)}
              </div>
            </div>
          ))}

          {filteredMatches().length === 0 && <p>{t("Loading")}</p>}
        </div>

        {message && <div className="message-box">{message}</div>}
      </div>
    );
  }

  // SCORE SELECTION GRID
  if (selectedMatch && !selectedScore) {
    const { home, draw, away } = categorizeScoreOdds(
      selectedMatch.scoreOdds || []
    );

    const handleSelectScore = (odd) => {
      setSelectedScore(odd.score);
      const oddsNum = parseFloat(odd.odds);
      if (!isNaN(oddsNum)) {
        setBetAmount("");
      }
    };

    return (
      <div className="betting-container">
        <button className="back-button" onClick={() => setSelectedMatch(null)}>
          {t("X")}
        </button>

        <h2 className="score-title">{t("Score betting")}</h2>
        <p className="league-name">{selectedMatch.league || ""}</p>

        <p className="teams-vs">
          {selectedMatch.teamA}{" "}
          <span className="vs-text">VS</span>{" "}
          {selectedMatch.teamB}
        </p>

        <p className="match-info">
          {selectedMatch.matchDate} ({getDayName(selectedMatch.matchDate)}) ·{" "}
          {formatTime(selectedMatch.matchTime)}
        </p>

        <div className="score-columns-header">
          <span>{t("Home")}</span>
          <span>{t("draw")}</span>
          <span>{t("Away")}</span>
        </div>

        <div className="score-grid">
          <div className="score-column">
            {home.map((odd, i) => (
              <div key={odd.score + i} className="score-cell">
                <div className="score-row-top">
                  <span className="score-label">{odd.score}</span>
                  <span className="score-odds">
                    {Number(odd.odds).toFixed(2)}
                  </span>
                </div>
                <button
                  className="score-bet-btn"
                  onClick={() => handleSelectScore(odd)}
                >
                  {t("Bet")}
                </button>
              </div>
            ))}
          </div>

          <div className="score-column">
            {draw.map((odd, i) => (
              <div key={odd.score + i} className="score-cell">
                <div className="score-row-top">
                  <span className="score-label">{odd.score}</span>
                  <span className="score-odds">
                    {Number(odd.odds).toFixed(2)}
                  </span>
                </div>
                <button
                  className="score-bet-btn"
                  onClick={() => handleSelectScore(odd)}
                >
                  {t("Bet")}
                </button>
              </div>
            ))}
          </div>

          <div className="score-column">
            {away.map((odd, i) => (
              <div key={odd.score + i} className="score-cell">
                <div className="score-row-top">
                  <span className="score-label">{odd.score}</span>
                  <span className="score-odds">
                    {Number(odd.odds).toFixed(2)}
                  </span>
                </div>
                <button
                  className="score-bet-btn"
                  onClick={() => handleSelectScore(odd)}
                >
                  {t("Bet")}
                </button>
              </div>
            ))}
          </div>
        </div>

        {message && <div className="message-box">{message}</div>}
      </div>
    );
  }

  // CONFIRMATION SCREEN
  if (selectedMatch && selectedScore) {
    const oddsObj = selectedMatch.scoreOdds.find(
      (o) => o.score === selectedScore
    );
    const oddsValue = oddsObj ? parseFloat(oddsObj.odds) : 0;
    const amountNum = Number(betAmount) || 0;
    const profit = (amountNum * oddsValue) / 100;

    return (
      <div className="betting-container bet-ticket-screen">
        <div className="bet-ticket">
          <div className="ticket-top-line">
            <span className="ticket-time">
              {formatTime(selectedMatch.matchTime)}
            </span>

            {selectedMatch.league && (
              <span className="ticket-league">
                {selectedMatch.league}
              </span>
            )}

            <span className="ticket-date">
              {selectedMatch.matchDate}
            </span>
          </div>

          <div className="ticket-match-box">
            <div className="ticket-teams">
              <div className="ticket-team-left">
                <span className="ticket-team-name">
                  {selectedMatch.teamA}
                </span>
              </div>
              <span className="ticket-vs">VS</span>
              <div className="ticket-team-right">
                <span className="ticket-team-name">
                  {selectedMatch.teamB}
                </span>
              </div>
            </div>

            <div className="ticket-score-line">
              <span className="ticket-score-label">
                {t("Score")}
              </span>
              <span className="ticket-score-value">
                {selectedScore}{" "}
                <span className="ticket-score-odds">
                  odds {oddsValue.toFixed(2)}%
                </span>
              </span>
            </div>
          </div>

          <div className="ticket-balance-section">
            <div className="ticket-balance-row">
              <span className="ticket-balance-label">
                {t("Balance")} TZS
              </span>
              <span className="ticket-balance-value">
                {tshBalance.toLocaleString()} TZS
              </span>
            </div>

            {Number(usdtBalance) > 0 && (
              <div className="ticket-balance-row">
                <span className="ticket-balance-label">
                  {t("Balance")} $
                </span>
                <span className="ticket-balance-value">
                  {usdtBalance.toFixed(2)} $
                </span>
              </div>
            )}

            <div className="ticket-input-block">
              <label className="bet-label">
                {t("Enter amount")}
              </label>

              <div className="ticket-amount-row">
                <input
                  type="number"
                  className="bet-amount-input"
                  placeholder={t("Enter bet amount")}
                  value={betAmount}
                  onChange={(e) => setBetAmount(e.target.value)}
                />

                <select
                  value={betCurrency}
                  onChange={(e) => setBetCurrency(e.target.value)}
                  className="bet-currency-select"
                >
                  <option value="TSH">{t("TZS")}</option>
                  {Number(usdtBalance) > 0 && (
                    <option value="USDT">{t("$")}</option>
                  )}
                </select>
              </div>

              <div className="ticket-all-buttons">
                <button
                  className="bet-all-btn"
                  onClick={() => {
                    setBetAmount(tshBalance);
                    setBetCurrency("TSH");
                  }}
                >
                  {t("All tzs")}
                </button>

                {Number(usdtBalance) > 0 && (
                  <button
                    className="bet-all-btn"
                    onClick={() => {
                      setBetAmount(usdtBalance);
                      setBetCurrency("USDT");
                    }}
                  >
                    {t("$")}
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="ticket-summary-table">
            <div className="ticket-summary-row">
              <span className="ticket-summary-label">
                {t("Total amount")}
              </span>
              <span className="ticket-summary-value">
                {amountNum.toLocaleString()} {betCurrency}
              </span>
            </div>

            <div className="ticket-summary-row">
              <span className="ticket-summary-label">
                {t("Total profit")}
              </span>
              <span className="ticket-summary-value ticket-profit">
                {profit.toFixed(2)} {betCurrency}
              </span>
            </div>
          </div>

          <button
            className="bet-primary-btn"
            onClick={handleBuy}
            disabled={isPlacing}
          >
            {isPlacing ? t("Processing...") : t("Bet")}
          </button>
        </div>

        {message && <div className="message-box bet-message">{message}</div>}
      </div>
    );
  }

  return null;
}